import template from './ticketCommercialLoan.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    commercialLoan: '<',
    lenders: '<',
    countries: '<',
    isTicketSettled: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdMedia,
      helperService,
      TicketCommercialLoanSecuritySplit,
      TicketLoanDetailsSplit,
      TicketCommercialLoanSecuritySplitType,
      OwnershipType,
      PropertyType,
      ZoningOption
    ) {
      'ngInject';
      /*
       * Controller model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.contacts = [];
      ctrl.currentOrganization = null;
      ctrl.currentCurrency = null;
      ctrl.organizationCountry = '';
      ctrl.organizationVat = 0;
      ctrl.availableTicketCommercialLoanSecuritySplitTypes = [];
      ctrl.availableZoningOptions = [];
      ctrl.availablePropertyTypes = [];
      ctrl.availableOwnershipTypes = [];
      ctrl.availableTermInYears = [];
      ctrl.searchTerm = '';
      ctrl.isReady = false;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.currentOrganization = $rootScope.CurrentOrganization;
        ctrl.currentCurrency = $rootScope.CurrentCurrency();
        ctrl.organizationCountry = helperService.getOrganizationCountry().name;
        ctrl.organizationVat = helperService.getOrganizationVat();
        ctrl.availableTicketCommercialLoanSecuritySplitTypes = TicketCommercialLoanSecuritySplitType.available();
        ctrl.availableZoningOptions = ZoningOption.available();
        ctrl.availablePropertyTypes = PropertyType.available();
        ctrl.availableOwnershipTypes = OwnershipType.available();
        ctrl.availableTermInYears = helperService.getAvailableTermInYears({ isRegular: true });
        ctrl.commercialLoan = ctrl.commercialLoan || {};
        ctrl.lenders = ctrl.lenders || [];
        ctrl.countries = ctrl.countries || [];
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.isReady = true;
      };

      ctrl.ticketCommercialLoanSecuritySplitAdd = ($event, securityType) => {
        $event.stopPropagation();
        ctrl.commercialLoan.dealCommercialLoanSecuritySplit.push(
          TicketCommercialLoanSecuritySplit.blank(securityType)
        );
      };

      ctrl.ticketCommercialLoanSecuritySplitDelete = (index) => {
        ctrl.commercialLoan.dealCommercialLoanSecuritySplit.splice(index, 1);
        ctrl.saveTicketCommercialLoan();
      };

      ctrl.ticketCommercialLoanDetailsSplitAdd = ($event) => {
        $event.stopPropagation();
        ctrl.commercialLoan.details.dealCommercialLoanDetailsSplit.push(
          TicketLoanDetailsSplit.blank()
        );
      };

      ctrl.ticketCommercialLoanDetailsSplitDelete = (index) => {
        ctrl.commercialLoan.details.dealCommercialLoanDetailsSplit.splice(index, 1);
        ctrl.saveTicketCommercialLoan();
      };

      ctrl.isTypeInvestmentOrProperty = (securitySplit) =>
        securitySplit?.securityType?.id ===
          TicketCommercialLoanSecuritySplitType.available()[0].id ||
        securitySplit?.securityType?.id ===
          TicketCommercialLoanSecuritySplitType.available()[2].id;

      ctrl.isTypeCashDeposit = (securitySplit) =>
        securitySplit?.securityType?.id ===
        TicketCommercialLoanSecuritySplitType.available()[1].id;

      ctrl.clearSearchTerm = () => {
        ctrl.searchTerm = '';
      };

      ctrl.isLenderSelected = (lender) => {
        if (lender && ctrl.lenders.length) {
          const lS = ctrl.lenders.find((l) => l.abbr.toLowerCase() === lender);
          return lS !== undefined;
        }
        return true;
      };

      ctrl.totalCommercialFees = () => {
        let total = 0;
        Object.keys(ctrl.commercialLoan.fees).forEach((key) => {
          total += helperService.isNumber(ctrl.commercialLoan.fees[key], true);
        });
        return total;
      };

      /*
       * Save ticket commercial loan
       * --------------------------------------------------------------------------------
       */
      ctrl.saveTicketCommercialLoan = () =>
        ctrl.onFinished({ commercialLoan: ctrl.commercialLoan });

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = function () {
        ctrl.initialize();
      };
    }
  }
};
